export default __webpack_public_path__ + "static/media/Thumb_Hairstyle_02.bf01309c.png";